module.exports = __webpack_public_path__ + "img/racecourse-scottsville-turf-inner-1750.d8d10a45.svg";